'use es6';

import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { fromJS, List } from 'immutable';
import indexBy from 'transmute/indexBy';
import get from 'transmute/get';
const mergeChatflowAndChannel = chatflow => {
  const {
    chatflowsMetadata = {},
    channelInstance = {}
  } = chatflow;
  return Object.assign({}, chatflowsMetadata, {
    channelId: channelInstance.channelId,
    createdAt: channelInstance.createdAt,
    active: channelInstance.isActive,
    inboxId: channelInstance.inboxId,
    name: channelInstance.name,
    routingRulesId: channelInstance.routingRulesId
  });
};
const formatChatflowByUniqueIdReference = chatflow => {
  const mergedChatflow = mergeChatflowAndChannel(chatflow);
  return new ReferenceRecord({
    id: String(mergedChatflow.id),
    label: mergedChatflow.name,
    referencedObject: fromJS(mergedChatflow)
  });
};
export const formatChatflowsByUniqueId = chatflows => {
  return indexBy(get('id'), List(chatflows).map(formatChatflowByUniqueIdReference));
};
export default formatChatflowsByUniqueId;